<template>
	<div class="switch">
		<div ref="switch-container" :data-item-active="currentActiveItem" :class="containerClass" class="switch-container">
			<div class="switch-slider"></div>
			<div class="row centered">
				<div v-for="(item, index) in items" class="switch-selector" :class="'option-'+index" @click="clickItem(index)"><p>{{ item }}</p></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppTabsSwitch",
	emits: ["switched"],
	data() {
		return {
			currentActiveItem: Number(this.activeItem),
		}
	},
	props: {
		activeItem: {type: Number, default: 0},
		autoSwitch: {type: Boolean, default: false},
		items: {type: Array, required: true, validator(value) { return value.length > 1 && value.length < 5 && value.every(item => { return typeof item === 'string'; }); }},
	},
	methods: {
		clickItem(index) {
			if (this.currentActiveItem !== index) {
				this.currentActiveItem = index;
				this.$emit('switched', index);
			} else {
				if(this.autoSwitch) {
					this.currentActiveItem = index === 0 ? 1 : 0;
					this.$emit('switched', this.currentActiveItem);
				}
			}
		}
	},
	computed: {
		containerClass() {
			return 'elements'+this.items.length;
		}
	},
	watch: {
		activeItem(value) {
			this.currentActiveItem = value;
		}
	},
}
</script>

<style lang="scss" scoped>
.switch {
	@include centered;
	@include columnFlex;

	p {
		margin-bottom: 5px;
		text-align: left;
		color: $txt_1;
		font-size: 10px;
		line-height: 15px;
		padding: 0 10px;
		width: 100%;
		margin-right: auto;
	}
}

.switch-container {
	position: relative;
	display: inline-block;
	height: 35px;
	cursor: pointer;
	width: 100%;
	min-width: 208px;
	max-width: 408px;

	&.elements2 {
		width: 208px;
	}

	&.elements3 {
		width: 308px;
	}

	&.elements4 {
		width: 408px;
	}

	& * {
		@include noSelect;
	}

	.row {
		height: 100%;
		position: absolute;
		top: 0;
		padding: 0 4px;

		.switch-selector {
			display: flex;
			@include centered;
			height: 100%;
			width: 100px;

			p {
				color: $txt_0;
				z-index: 1;
				width: 100%;
				text-align: center;
				margin-bottom: 0;
			}
		}
	}

	.switch-slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--color-bg);
		-webkit-transition: .4s;
		transition: .4s;
		box-shadow: 0 1px 2px var(--color-box-shadow-3);
		border-radius: 13px;

		&:before {
			position: absolute;
			content: "";
			height: 29px;
			width: 100px;
			left: 4px;
			top: 50%;
			transform: translateY(-50%);
			background-color: var(--color-bg-primary-4);
			-webkit-transition: left .3s $transition;
			transition: left .3s $transition;
			border-radius: 11px;
			box-shadow: inset 0 2px 3px var(--color-box-shadow-dark-2);
		}
	}

	&[data-item-active="0"] {
		.row .switch-selector:nth-of-type(1) p {
			color: $bg_0;
		}
	}

	&[data-item-active="1"] {
		.row .switch-selector:nth-of-type(2) p {
			color: $bg_0;
		}
	}

	&[data-item-active="2"] {
		.row .switch-selector:nth-of-type(3) p {
			color: $bg_0;
		}
	}

	&[data-item-active="3"] {
		.row .switch-selector:nth-of-type(4) p {
			color: $bg_0;
		}
	}

	.switch-selector p {
		@include truncateString;
		transition: color .3s $transition;
	}

	&.elements2 {
		.switch-slider:before {
			width: calc((100% - 8px) / 2);
		}

		.switch-selector {
			width: 50%;
		}

		&[data-item-active="1"] .switch-slider:before {
			left: 50%;
		}
	}

	&.elements3 {
		.switch-slider:before {
			width: calc((100% - 8px) / 3);
		}

		.switch-selector {
			width: calc(100% / 3);
		}

		&[data-item-active="1"] .switch-slider:before {
			left: calc((100% / 3) + 2px);
		}

		&[data-item-active="2"] .switch-slider:before {
			left: calc((100% / 3 * 2) - 2px);
		}
	}

	&.elements4 {
		.switch-slider:before {
			width: calc((100% - 8px) / 4);
		}

		.switch-selector {
			width: 25%;
		}

		&[data-item-active="1"] .switch-slider:before {
			left: calc(25% + 2px);
		}

		&[data-item-active="2"] .switch-slider:before {
			left: 50%;
		}

		&[data-item-active="3"] .switch-slider:before {
			left: calc(75% - 2px);
		}
	}

	@media (max-width: 460px) {
		min-width: 168px;
		max-width: 328px;

		&.elements2 {
			width: 168px;
		}
		&.elements3 {
			width: 248px;
		}
		&.elements4 {
			width: 328px;
		}
		.switch-selector p {
			padding: 0 6px;
		}
	}

	@media (max-width: 300px) {
		min-width: 88px;
		max-width: 168px;

		&.elements2 {
			width: 88px;
		}
		&.elements3 {
			width: 128px;
		}
		&.elements4 {
			width: 168px;
		}
		.switch-selector p {
			font-size: 10px;
			padding: 0 4px;
		}
	}
}

</style>